import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import TaskCompleted from 'main/components/modals/task_modal/TaskCompleted';
import PerformanceReviewTask from 'main/components/modals/task_modal/PerformanceReviewTask';
import PerformanceSurveyTask from 'main/components/modals/task_modal/PerformanceSurveyTask';
import DocumentTask from 'main/components/modals/task_modal/DocumentTask';
import TextDescriptionTask from 'main/components/modals/task_modal/TextDescriptionTask';
import TrainingTask from 'main/components/modals/task_modal/TrainingTask';
import OfferTask from 'main/components/modals/task_modal/OfferTask';
import ExpenseTask from 'main/components/modals/task_modal/ExpenseTask';
import InterviewAppSetupTask from 'main/components/modals/task_modal/InterviewAppSetupTask';

function taskItem(task, uiState) {
  switch (task.taskType) {
    case 'reviewee':
      return <PerformanceReviewTask uiState={uiState}/>;
    case 'survey':
      return <PerformanceSurveyTask uiState={uiState}/>;
    case 'document':
      return <DocumentTask uiState={uiState}/>;
    case 'training':
      return <TrainingTask uiState={uiState}/>;
    case 'offer':
      return <OfferTask uiState={uiState}/>;
    case 'expense':
      return <ExpenseTask uiState={uiState}/>;
    case 'interview_app_setup':
      return <InterviewAppSetupTask uiState={uiState}/>;
    case 'onboarding':
    case 'offboarding':
      return <TextDescriptionTask uiState={uiState}/>;
    default:
      return null;
  }
}

const TaskContentSwitch = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      {taskItem(task, uiState)}
      {task.completed && <div className='mt2'><TaskCompleted uiState={uiState} /></div>}
    </div>
  );
});

const TaskTitle = observer(({task}) => {
  if (task.taskType === 'interview_app_setup') {
    const titleKey = task.relatedAttributes.purposes.sort().join('_');

    return <FormattedMessage id={`inbox.interview_app_setup.title.${titleKey}`}/>;
  }

  return task.name;
});

const TaskContent = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      <div className='h2 mb2'><TaskTitle task={task}/></div>
      <TaskContentSwitch uiState={uiState}/>
    </div>
  );
});

export default TaskContent;
